import Vue from 'vue'
import Router from 'vue-router'
// import Hello from '@/components/HelloWorld'
// import Posts from '@/components/Posts'
import About from '@/components/AboutUs'
import DayTours from '@/components/DayTours'
import MultiDayTours from '@/components/MultiDayTours'
import TailorMade from '@/components/TailorMade'
import Slider from '@/components/ImageSlider'
// import Gallery from '@/components/IndexGallery'
// import Footer from '@/components/Footer'
import DayTour1 from '@/components/DT1_ThroughCanyons'
import DayTour2 from '@/components/DT2_CircleAroundKorita'
import DayTour3 from '@/components/DT3_CanyonForestCheese'
import DayTour4 from '@/components/DT4_NaturalBeauties'
import DayTour5 from '@/components/DT5_AmongKatuns'
import DayTour6 from '@/components/DT6_SkadarLake'
import Cultour from '@/components/Cultour'
import CultourMultiDayTours from '@/components/CultourMultiDayTours'
import Cultour1 from '@/components/CT1_Stecci'
import Cultour2 from '@/components/CT2_Podgorica'
import Cultour3 from '@/components/CT3_Kotor'
import Cultour4 from '@/components/CT4_VillagesAndTowns'
import Cultour5 from '@/components/CT5_UnescoHeritage'
import Cultour6 from '@/components/CT6_KatunFairyTale'
import MultiDayTour1 from '@/components/MT1_AmazingNorth'
import MultiDayTour2 from '@/components/MT2_NationalParks'
import MultiDayTour3 from '@/components/MT3_MagnificentDurmitor'
import RuralMontenegro from '@/components/RuralMontenegro'
import FamilyBuilding from '@/components/FamilyBuilding'
import RuralTour1 from '@/components/RT1_RuralMontenegro'
import PlacesToGo1 from '@/components/PTG1_SkadarLake'
import PlacesToGo2 from '@/components/PTG2_OldMontenegro'
import PlacesToGo3 from '@/components/PTG3_Podgorica'
import PlacesToGo4 from '@/components/PTG4_OldSouthTowns'
import PlacesToGo5 from '@/components/PTG5_NorthMontenegro'
import PlacesToGo6 from '@/components/PTG6_UnescoSites'
import Blog from '@/components/Blog'
import Terms from '@/components/TermsAndConditions'
import Reviews from '@/components/MoreReviews'
import TravelPolicy from '@/components/ResponsibleTravelPolicy'

import Contact from '@/components/Contact'

Vue.use(Router)

export default new Router({
  mode: 'history',
  hash: false,
  routes: [
    // {
    // path: '/',
    // name: 'Slider',
    // component: Slider
    // },
    {
      path: '/about',
      name: 'About us',
      component: About
    },
    {
      path: '/tailormade',
      name: 'Tailor-made tours',
      component: TailorMade
    },
    {
      path: '/daytours',
      name: 'Day Tours',
      component: DayTours
    },
    {
      path: '/multidaytours',
      name: 'Multi-day Tours',
      component: MultiDayTours
    },
    {
      path: '/index',
      name: 'Home',
      component: Slider
    },
    {
      path: '/',
      name: 'Home',
      component: Slider
    },
    {
      path: '/daytour1',
      name: 'ThroughCanyons',
      component: DayTour1
    },
    {
      path: '/daytour2',
      name: 'CircleAroundKorita',
      component: DayTour2
    },
    {
      path: '/daytour3',
      name: 'CanyonForestCheese',
      component: DayTour3
    },
    {
      path: '/daytour4',
      name: 'NaturalBeauties',
      component: DayTour4
    },
    {
      path: '/daytour5',
      name: 'AmongKatuns',
      component: DayTour5
    },
    {
      path: '/daytour6',
      name: 'SkadarLake',
      component: DayTour6
    },
    {
      path: '/cultour1',
      name: 'ThroughCanyons',
      component: Cultour1
    },
    {
      path: '/cultour',
      name: 'Cultour',
      component: Cultour
    },
    {
      path: '/cultour_multiday',
      name: 'CultourMultiDayTours',
      component: CultourMultiDayTours
    },
    {
      path: '/cultour2',
      name: 'ThroughCanyons',
      component: Cultour2
    },
    {
      path: '/cultour3',
      name: 'ThroughCanyons',
      component: Cultour3
    },
    {
      path: '/cultour4',
      name: 'VillagesAndTowns',
      component: Cultour4
    },
    {
      path: '/cultour5',
      name: 'UnescoHeritage',
      component: Cultour5
    },
    {
      path: '/cultour6',
      name: 'KatunFairyTale',
      component: Cultour6
    },
    {
      path: '/rural',
      name: 'RuralMontenegro',
      component: RuralMontenegro
    },
    {
      path: '/familyBuilding',
      name: 'FamilyBuilding',
      component: FamilyBuilding
    },
    {
      path: '/multidaytour1',
      name: 'AmazingNorth',
      component: MultiDayTour1
    },
    {
      path: '/multidaytour2',
      name: 'NationalParks',
      component: MultiDayTour2
    },
    {
      path: '/multidaytour3',
      name: 'MagnificentDurmitor',
      component: MultiDayTour3
    },
    {
      path: '/ruraltour1',
      name: 'RuralTour1',
      component: RuralTour1
    },
    {
      path: '/placestogo1',
      name: 'SkadarLake',
      component: PlacesToGo1
    },
    {
      path: '/placestogo2',
      name: 'OldMontenegro',
      component: PlacesToGo2
    },
    {
      path: '/placestogo3',
      name: 'Podgorica',
      component: PlacesToGo3
    },
    {
      path: '/placestogo4',
      name: 'SkadarLake',
      component: PlacesToGo4
    },
    {
      path: '/placestogo5',
      name: 'SkadarLake',
      component: PlacesToGo5
    },
    {
      path: '/placestogo6',
      name: 'SkadarLake',
      component: PlacesToGo6
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/reviews',
      name: 'Reviews',
      component: Reviews
    },
    {
      path: '/policy',
      name: 'ResponsibleTravelPolicy',
      component: TravelPolicy
    },
    {
      path: '*',
      name: 'catchAll',
      component: Slider
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js